var BaseView = require('../components/accordion-list/director');

module.exports = BaseView.extend({
  class: 'admin',
  views: {},
  Views: {
    templates: require('./contents/template/view'),
    backgrounds: require('./contents/background/view'),
    stickers: require('./contents/sticker/view'),
    banners: require('./contents/banners/view'),
    placeholders: require('./contents/placeholders/view'),
    migrate: require('./contents/migrate/view')
  },
  buttons: [
    { key: 'templates', tag: 'editor.templates', icon: 'icon-news' },
    { key: 'backgrounds', tag: 'editor.backgrounds', icon: 'icon-backgrounds' },
    { key: 'stickers', tag: 'editor.stickers', icon: 'icon-hipster' },
    { key: 'banners', tag: 'editor.text_banners', icon: 'icon-font_download' },
    { key: 'placeholders', tag: 'common.image_placeholders', icon: 'icon-image' },
    { key: 'migrate', tag: 'tool.admin.migrate', icon: 'icon-forward' }
  ],

  render: function () {
    var html = this.template({
      class: this.class,
      buttons: this.buttons
    });

    this.$el.html(html);
  }
});
